// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form .el-table .cell .el-form-item__content[data-v-43685294] {\n  line-height: normal;\n}", ""]);
// Exports
module.exports = exports;
